<template>
  <div class="restaurant-card">
    <img class="restaurant-image" :src="imageUrl" :alt="restaurant.name">
    <div class="restaurant-info">
      <h1 class="restaurant-name">{{ restaurant.name }}</h1>
      <span class="restaurant-world">
        <LocationMarker />
        {{ restaurant.world }}
      </span>
      <p class="restaurant-description">{{ restaurant.description[codeLang] }}</p>
      <a class="restaurant-link" :href="restaurant.link" target="_blank">{{ translations.SeeMenu }}</a>
    </div>
  </div>
</template>

<script>
import LocationMarker from '@/components/LocationMarker.vue'
import { mapState } from 'vuex'
export default {
  name: 'RestaurantCard',
  props: {
    restaurant: {
      type: Object,
      required: true
    }
  },
  components: {
    LocationMarker
  },
  computed: {
    ...mapState(['codeLang', 'translations']),
    imageUrl () {
      return require('../assets/img/' + this.restaurant.image)
    }
  }
}
</script>

<style>
.restaurant-card {
  border-radius: 1.5rem;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  max-width: 300px;
  overflow: hidden;
  --tw-shadow-color: 0, 0, 0;
  --tw-shadow: 0 10px 15px -3px rgba(var(--tw-shadow-color), 0.1), 0 4px 6px -2px rgba(var(--tw-shadow-color), 0.05);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.restaurant-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  padding: 1rem;
  text-align: center;
}
.restaurant-name {
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(50, 51, 147, var(--tw-text-opacity));
}
.restaurant-world {
  font-weight: 700;
  margin-top: 0.5rem;
}
.restaurant-description {
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(141, 141, 141, var(--tw-text-opacity));
  letter-spacing: 0.025em;
}
.restaurant-link {
  --tw-bg-opacity: 1;
  background-color: rgba(250, 89, 22, var(--tw-bg-opacity));
  border-radius: 1.5rem;
  display: block;
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.75rem;
  margin-top: 1.5rem;
  padding: 0.75rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
</style>
